import React from 'react';
import { makeObservable, observable, action } from 'mobx';
import UserSettingsRequests from 'Utils/Requests/UserSettingsRequests';
import AppStore from 'Stores/AppStore';
import TracesStore from 'Stores/tracesStore';
import UsersSyncStore from 'Stores/UsersSyncStore';
import { ShowAlert, ShowModal, CloseModal, SynchronizingTask, SynchronizingStatus } from "Utils/CommonFunctions";
import Enumerable from "linq";
import SynchronizingModal from "Components/UserSettings/synchronizingModal";
import EndOfSyncModal from "Components/UserSettings/endOfSyncModal";
import IconsContainer from 'Utils/IconsContainer';
import { WebErrorCodeEnum } from 'Utils/Requests/WebEnums';
import Helper from 'Utils/Helper';

class UserSettingsStore {
    /** @type {UserSettings} */
    settings;
    /** @type {UserSettings} */
    settingsAfterLoad;
    copySettingsFrom;
    selectAssistent;
    modal;
    synchronizing;
    rubricsLoading;
    acceptedEdsAgreement;
    startDateFromServer;
    redirectTo404;
    supportEmailError;
    meetingSupportEmailError;
    rubrics;
    /** @type {WebCertificateInfo[]} */
    deviceCertificates;
    /** @type {WebLicenseInfo[]} */
    deviceLicenses;

    userLid;
    userId;
    userName;
    userInfo;
    updateUserInfoTimerId;
    updateUserInfoTimerInterval;

    historyLifetime;
    timeoutSecPresets;
    initiativeGroupList;

    importFileData;
    oldDocumentsLoaded;
    /** @type {PersonSearchResult[]} */
    assistentSearchResult;
    settingsAreLoading;
    blockWindow;
    syncModalTypeOpened;
    edsArchive;
    /** @type {GetCabinetDLsResult?} */
    cabinetDLs;
    cabinetDLsContactLidsToAdd;
    cabinetDLsContactLidsToSave;
    cabinetDLLidSelectedFirst;
    usersReloadState;
    /** @type {UserState} */
    currentUserState;
    dmsisStatus;
    renderStore;

    constructor() {
        makeObservable(this, {
            settings: observable,
            copySettingsFrom: observable,
            selectAssistent: observable,
            modal: observable,
            synchronizing: observable,
            rubricsLoading: observable,
            acceptedEdsAgreement: observable,
            startDateFromServer: observable,
            userInfo: observable,
            redirectTo404: observable,
            settingsAreLoading: observable,
            blockWindow: observable,
            cabinetDLs: observable,
            cabinetDLLidSelectedFirst: observable,
            usersReloadState: observable,
            currentUserState: observable,
            dmsisStatus: observable,
            oldDocumentsLoaded: observable,
            renderStore: observable,
            deviceCertificates: observable,
            deviceLicenses: observable,
        });

        this.updateUserInfoTimerInterval = 1000;

        this.ClearStore();
    }

    ClearStore = action(() => {

        //--- properties

        this.deviceCertificates = [];
        this.deviceLicenses = [];
        this.settings = this.GetDefaultSettingsState();
        this.settingsAfterLoad = this.GetDefaultSettingsState();
        this.copySettingsFrom = {};
        this.selectAssistent = {
            alias: '',
            list: []
        };
        this.modal = {
            show: false,
            type: ''
        };
        this.synchronizing = {
            inProgress: false,
            task: 0,
            documents: {
                status: 0,
                total: 0,
                downloaded: 0
            }
        };
        this.rubricsLoading = false;
        this.acceptedEdsAgreement = false;
        //startDateFromServer
        //redirectTo404
        this.supportEmailError = false;
        this.meetingSupportEmailError = false;
        this.rubrics = [];

        this.userLid = '';
        //userId;
        //userName;
        this.userInfo = {};

        this.historyLifetime = [];
        this.timeoutSecPresets = [];
        this.initiativeGroupList = [];

        this.importFileData = {
            clicks: 0,
            clearKey: 0
        };
        //oldDocumentsLoaded;
        //assistentSearchResult;
        this.settingsAreLoading = null;
        this.blockWindow = false;
        this.syncModalTypeOpened = "";
        this.edsArchive = null;
        this.ClearDLs();
        this.needUpdateAfterSyncSettingsAll = false;
        this.needUpdateAfterSyncSettingsDls = false;
        this.needUpdateAfterSyncDictionaries = false;
        this.usersReloadState = [];
        this.currentUserState = {};
        this.dmsisStatus = {};

        //--- other

        this.blockWindow = false;
        this.redirectTo404 = false;
        this.notConsideredFolder = false;
        this.isSearchEnabled = false;
        this.userFolders = false;
        this.renderStore = {};
        this.alertAssistentsDeletedShowed = false;
    });
    ClearDLs = action(() => {
        this.cabinetDLs = null;
        this.cabinetDLsContactLidsToAdd = [];
        this.cabinetDLsContactLidsToSave = [];
        this.cabinetDLLidSelectedFirst = null;
    });

    //todo получить с backend
    GetDefaultSettingsState() {
        return {
            receiveDocumentsFrom: { value: '01.01.2000' },
            maxFileSizeMb: { value: 0 },
            notLoadOperationsFiles: { value: true },
            mainAssistentUserLid: { value: null },
            assistents: { value: [] },
            useAssistentDictionaries: { value: false, disabled: true },
            gatewayAssistent: { value: false, disabled: true },
            canImprovement: { value: false, disabled: true },
            sendProjectsViaAssistent: { value: false, disabled: true },
            canReport: { value: false, disabled: true },
            isReportRequired: { value: false, disabled: true },
            gatewayVisaAssistant: { value: false, disabled: true },
            gatewaySignAssistant: { value: false, disabled: true },
            controlFolder: { value: false, disabled: true },
            superiorControlFolder: { value: false, disabled: true },
            personalControlFolder: { value: false, disabled: true },
            initiativeControlFolder: { value: false, disabled: true },
            allReceivedFolder: { value: false, disabled: true },
            inWorkFolder: { value: false, disabled: true },
            familarizationFolder: { value: false, disabled: true },
            urgentFolder: { value: false, disabled: true },
            notConsideredFolder: { value: false, disabled: false },
            isSearchEnabled: { value: false, disabled: false },
            userFolders: { value: false, disabled: false },
            visaFolder: { value: false, disabled: true },
            signFolder: { value: false, disabled: true },
            historyInterval: { value: 0 },
            rootRubricName: { value: '' },
            rubricsInResolutionFolder: { value: false, disabled: true },
            rubricsInVisaFolder: { value: false, disabled: true },
            rubricsInSignFolder: { value: false, disabled: true },
            markAsReadTimeoutSec: { value: 0 },
            canSaveFiles: { value: false, disabled: true },
            initiativeResolutionGroupLid: { value: '' },
            copyResolutionTextToDocDesc: { value: true },
            copyTextFromParentRes: { value: false, disabled: true },
            copyIntermediateDateFromParentRes: { value: false, disabled: true },
            canAddInfExecutors: { value: false, disabled: true },
            canAddSeveralRespExecutors: { value: false, disabled: true },
            respExecutorRequired: { value: false, disabled: true },
            selectIntermediateDate: { value: false, disabled: true },
            alwaysExecuteResolution: { value: false, disabled: true },
            canEdsResolution: { value: false, disabled: true },
            canEdsInitiative: { value: false, disabled: true },
            requireEdsOnResolution: { value: false, disabled: true },
            canEdsVisa: { value: false, disabled: true },
            requireEdsOnVisa: { value: false, disabled: true },
            canEdsSign: { value: false, disabled: true },
            requireEdsOnSign: { value: false, disabled: true },
            canAnnotate: { value: false, disabled: true },
            canAnnotateForVisa: { value: false, disabled: true },
            canAnnotateForSign: { value: false, disabled: true },
            newFolder: { value: false, disabled: true },
            newFolderProjects: { value: false, disabled: true },
            doNotShowPartlyHandledDocuments: { value: false, disabled: false },
            addUrgentProjectsToUrgentFolder: { value: false, disabled: true },
            coordinateProjectsWithoutDialogWindow: { value: false, disabled: false },
            approveProjectsWithoutDialogWindow: { value: false, disabled: false },
            projectFolder: { value: false, disabled: false },
            underConsiderationFolder: { value: true, disabled: false },
            notReceiveForForwarding: { value: false, disabled: false }
        };
    }

    UnblockWindow = action(_ => this.blockWindow = false);

    PickImportSettingsFile(e) {
        if (e.altKey !== true || e.shiftKey !== true) return;

        this.importFileData.clicks++;

        if (this.importFileData.clicks !== 5) {
            let key = Math.floor(Math.random() * 10000);
            this.importFileData.clearKey = key;

            setTimeout(function () {
                if (this.importFileData.clearKey === key) {
                    this.importFileData = {
                        clearKey: 0,
                        clicks: 0
                    };
                }
            }.bind(this), 1000)

            return;
        }

        let input = document.createElement("input");
        input.type = "file";
        input.style = { display: 'none' };

        input.onchange = this.ImportSettingsFilePickedHandler.bind(this);

        document.body.appendChild(input);

        this.importFileData.clicks = 0;

        input.click();
    }

    ImportSettingsFilePickedHandler(e) {
        let ignoredSettings = [
            "receiveDocumentsFrom",
            "edsArchiveName",
            "meetingEdsArchiveName",
            "edsArchiveId",
            "meetingEdsArchiveId",
            "edsArchiveAutoUpload",
            "meetingEdsArchiveAutoUpload",
            //далее настройки, которые надо загрузить с сервака
            "initiativeResolutionGroupLid",
            "rootRubricId",
            "rootRubricName",
            "assistentLid",
            "assistentName"
        ];

        let fr = new FileReader();
        fr.onload = action(function () {
            let settingsBackend = JSON.parse(fr.result).user.settings;

            UserSettingsRequests.GetImportSettingsDefaults(this.userId).then((values) => {
                let settings = this.ConvertSettingsFromBackendToFront(settingsBackend);
                Object.keys(settingsFront).filter(it => ignoredSettings.some(it3 => it3 == it) == false).forEach(key => {
                    this.settings[key] = settings[key];
                });

                //todo возможно убрать
                if (settings['mainAssistentUserLid'] != null) {
                    this.settings['mainAssistentUserLid'].value = values.mainAssistentUserLid;
                    this.settings['assistents'].value = values.assistents;
                }
                else {
                    this.settings['mainAssistentUserLid'].value = '';
                    this.settings['assistents'].value = '';
                }

                if (settings['rootRubricId'] != null) {
                    this.settings['rootRubricId'].value = values.rootRubricId;
                    this.settings['rootRubricName'].value = values.rootRubricName;
                } else {
                    this.settings['rootRubricId'].value = '';
                    this.settings['rootRubricName'].value = '';
                }

                if (settings['initiativeResolutionGroupLid'] !== '') {
                    this.settings['initiativeResolutionGroupLid'].value = values.initiativeResolutionGroupLid;
                } else {
                    this.settings['initiativeResolutionGroupLid'].value = '';
                }

                this.AfterSetSettings();
            })

            document.body.removeChild(e.target);
        }.bind(this));

        fr.readAsText(e.target.files[0]);
    }

    GetRubricsForModal = action(() => {
        this.rubricsLoading = true;

        UserSettingsRequests.GetRubrics().then(action((values) => {
            if (values.error) {
                ShowAlert('warning',
                    <div>
                        При попытке получить данные из сервера интеграции произошла ошибка.<br />
                        Убедитесь, что сервер интеграции работает, и повторите попытку.
                    </div>
                );

                this.blockWindow = true;
            } else {
                this.rubrics = values.value;
            }
        }))
            .finally(action(() => this.rubricsLoading = false));
    });

    GetSettings = action((funcDoAfterGet) => {
        this.GetCabinetDLs();

        this.settingsAreLoading = true;

        UserSettingsRequests.GetSettings(this.userId).then(action((values) => {
            if (values.error) {
                if (values.error.errorCode === WebErrorCodeEnum.DmsisNotWorkingError) {
                    ShowAlert('warning',
                        <div>
                            При попытке получить данные из сервера интеграции произошла ошибка.<br />
                            Убедитесь, что сервер интеграции работает, и повторите попытку.
                        </div>
                    );

                    this.blockWindow = true;
                }
                else if (values.error.errorCode === WebErrorCodeEnum.UserNotExistsError) {
                    this.redirectTo404 = true;
                }
                return;
            }

            let pageTitleAdditionalInfo = ` ${values.settings.userName}`;
            if (values.settings.userPost)
                pageTitleAdditionalInfo += ` - ${values.settings.userPost}`;

            AppStore.pageTitleAdditionalInfo = pageTitleAdditionalInfo;

            let settingsCopy = this.ConvertSettingsFromBackendToFront(values.settings.settings);

            this.startDateFromServer = settingsCopy.receiveDocumentsFrom.value;

            this.SetCurrentUserState(values.userState);
            UsersSyncStore.usersState[this.userLid] = values.userState;

            this.ProcessUserInfo(values.userInfo);

            this.userName = values.settings.userName;
            this.copySettingsFrom = {
                users: values.initData.usersToCopySettings,
                selectedUser: values.initData.usersToCopySettings[0].key
            };
            this.historyLifetime = values.initData.historyLifetime;
            this.timeoutSecPresets = values.initData.timeoutSecPresets;
            this.initiativeGroupList = values.initData.initiativeGroupList;
            this.oldDocumentsLoaded = values.initData.oldDocumentsLoaded;
            this.userLid = values.settings.userLid;
            this.deviceCertificates = values.settings.deviceCerificates;
            this.deviceLicenses = values.settings.deviceLicenses;

            this.settings = Helper.CloneObject(settingsCopy);
            this.AfterSetSettings();
            this.settingsAfterLoad = Helper.CloneObject(this.settings);

            if (values.initData.showInitiativeLostError === true) {
                this.defaultInitiativeError = true;
                this.disabledInitiative = values.settings.settings.initiativeResolutionGroupLid;
                ShowAlert('error', `Группа для создания инициативных поручений более недоступна пользователю ${this.userName} Выберите доступную группу и нажмите "Сохранить" в профиле пользователя.`);
            }

            let deletedAssistents = this.settings.assistents.value.filter(x => x.deleted);
            if (deletedAssistents.length > 0 && !this.alertAssistentsDeletedShowed) {
                ShowAlert('error',
                    deletedAssistents.length == 1
                        ? `Пользователь с ролью помощника ${deletedAssistents[0].name} был удален из СЭД.`
                        : `Пользователи с ролью помощника ${deletedAssistents.map(it => it.name).join(", ")} были удалены из СЭД.`
                );
                this.alertAssistentsDeletedShowed = true;
            }

            if (funcDoAfterGet)
                funcDoAfterGet();
        }))
            .finally(action(() => this.settingsAreLoading = false));
    });

    ReloadSettings() {
        if (this.needUpdateAfterSyncSettingsAll || this.needUpdateAfterSyncDictionaries) {
            this.GetSettings();
        }
        else if (this.needUpdateAfterSyncSettingsDls) {
            this.GetCabinetDLs();
        }
        this.needUpdateAfterSyncSettingsAll = false;
        this.needUpdateAfterSyncDictionaries = false;
        this.needUpdateAfterSyncSettingsDls = false;
    }

    StartUpdateUserInfo = action(() => {
        clearInterval(this.updateUserInfoTimerId);
        this.updateUserInfoTimerId = setInterval(
            () => this.GetUserInfo(),
            this.updateUserInfoTimerInterval
        );
    });

    StopUpdateUserInfo = action(() => {
        clearInterval(this.updateUserInfoTimerId);
    });

    GetUserInfo = action(() => {
        UserSettingsRequests.GetUserInfo(this.userId)
            .then(action((values) => {
                this.ProcessUserInfo(values);
            }));
    });

    ProcessUserInfo(userInfo) {
        this.userInfo = userInfo;

        AppStore.meetingSwitcherEnabledCurrentUser = this.userInfo.meetingSwitcherEnabledCurrentUser;
    }

    ForceCloseSyncModal() {
        UserSettingsRequests.CleanUsersModal(this.userLid);
    }

    SaveSettings = action((doSyncUser) => {
        let settingsToSend = this.ConvertSettingsFromFrontToBackend(this.settings);

        if (doSyncUser == null)
            doSyncUser = false;

        this.settingsAreLoading = true;

        this.synchronizing.documents = {
            loaded: 0,
            total: 0
        };

        if (doSyncUser) {
            this.needUpdateAfterSyncSettingsDls = true;
        }

        UserSettingsRequests.SaveSettings(
            settingsToSend,
            this.userId,
            this.edsArchive,
            doSyncUser,
            this.settings.receiveDocumentsFrom.value,
            this.cabinetDLsContactLidsToSave
        ).then(action((values) => {
            this[this.GetPropertyNameOfCurrentProductMode("SupportEmailError")] = false;
            this.edsArchive = null;

            if (!values.error) {

                ShowAlert('success', 'Настройки успешно сохранены.');

                if (values.value.loadStarted) {
                    this.SetCurrentUserState(values.value.userState);
                }

                this.GetSettings(() => {
                    if (doSyncUser) { // если синхронизируем пользака, значит могла поменяться дата его синхронизации
                        this.startDateFromServer = this.settings.receiveDocumentsFrom.value;
                        this.oldDocumentsLoaded = true;
                    }
                }); // некоторые поля заполнются на backend, например EdsArchiveFileId
            } else {
                if (values.error.errorCode === WebErrorCodeEnum.UserNotExistsError) {
                    return;
                }

                if (values.error.errorCode === WebErrorCodeEnum.SupportEmailValidationError) {
                    this[this.GetPropertyNameOfCurrentProductMode("SupportEmailError")] = true;
                }

                ShowAlert('error',
                    <div>
                        При сохранении настроек произошла ошибка.<br />
                        {values.error.errorText ? values.error.errorText : "Убедитесь что СМР работает и повторите попытку."}
                    </div>
                );
            }
        }))
            .finally(action(() => this.settingsAreLoading = false));
    });

    CopySettings() {
        UserSettingsRequests.CopySettings(this.userId, this.copySettingsFrom.selectedUser).then(action((values) => {
            if (!values.error) {
                this.settings = this.ConvertSettingsFromBackendToFront(values.value.model.settings);

                this.AfterSetSettings();

                let userName = '';

                for (let i = 0; i < this.copySettingsFrom.users.length; i++) {
                    if (this.copySettingsFrom.users[i].key === this.copySettingsFrom.selectedUser) {
                        userName = this.copySettingsFrom.users[i].value;

                        break;
                    }
                }

                if (values.value.initiativeNotCopied)
                    ShowAlert('warning', `Группа инициативных поручений пользователя ${userName} недоступна пользователю ${this.userName}. Все настройки, кроме "Группа для создания инициативных поручений", успешно скопированы от пользователя ${userName}.`);
                else
                    ShowAlert('success', `Успешно скопированы настройки от ${userName}.`);
            } else {
                ShowAlert('error', values.error.errorText);
            }
        }));
    }

    SaveRubricInfo(id, name) {
        this.SetSetting('rootRubricName', name);
        this.SetSetting('rootRubricId', id);
    }

    GetPropertyNameOfCurrentProductMode(keyNameLikeBackend) {
        return this.GetSettingNameOfCurrentProductMode(keyNameLikeBackend);
    }

    // todo убрать конвертирование. вынести disabled в отдельную переменную
    ConvertSettingsFromBackendToFront(settingsBackend) {
        let settingsFront = {};
        Object.keys(settingsBackend).forEach(key => {
            settingsFront[key] = {
                value: settingsBackend[key],
                disabled: false
            }
        });
        return settingsFront;
    }

    ConvertSettingsFromFrontToBackend(settingsFront) {
        let settingsBackend = {};
        Object.keys(settingsFront).forEach(key => {
            settingsBackend[key] = settingsFront[key].value;
        });
        return settingsBackend;
    }

    GetSettingNameOfCurrentProductMode(keyNameLikeBackend) {
        let key = "";
        if (AppStore.isMeeting) {
            key = `meeting${keyNameLikeBackend}`;
        }
        else {
            key = `${keyNameLikeBackend.charAt(0).toLowerCase()}${keyNameLikeBackend.substring(1)}`;
        }
        return key;
    }

    GetSettingOfCurrentProductMode(keyNameLikeBackend) {
        return this.GetSetting(this.GetSettingNameOfCurrentProductMode(keyNameLikeBackend));
    }

    GetSettingDisabledValue(keyNameLikeBackend) {
        return this.settings[this.GetSettingNameOfCurrentProductMode(keyNameLikeBackend)]?.disabled;
    }

    GetSetting(key) {
        return this.settings[key]?.value;
    }

    SetSettingOfCurrentProductMode = action((keyNameLikeBackend, value) => {
        this.SetSetting(this.GetSettingNameOfCurrentProductMode(keyNameLikeBackend), value);
    });

    SetSettingDisabledValueOfCurrentProductMode = action((keyNameLikeBackend, disabled) => {
        let key = this.GetSettingNameOfCurrentProductMode(keyNameLikeBackend);
        this.SetSettingDisabledValue(key, disabled);
    });

    SetSettingDisabledValue = action((key, disabled) => {
        if (this.settings[key] == null) {
            this.settings[key] = { value: null, disabled: disabled };
        }
        if (disabled != null && this.settings[key].disabled != disabled) {
            this.settings[key].disabled = disabled;
        }
    });

    SetSetting = action((key, value, funcProcessAfterSetValue) => {
        if (this.GetSetting(key) == value)
            return;

        switch (key) {
            case 'underConsiderationFolder':
                if (this.oldDocumentsLoaded) {
                    ShowAlert('warning',
                        value
                            ? (<p>Для пользователя <b>{this.userName}</b> будут загружены документы для папки "На рассмотрение".</p>)
                            : (<p>Для пользователя <b>{this.userName}</b> будут удалены все документы, относящиеся к папке "На рассмотрение". Папка "На рассмотрение" и её папки-фильтры будут скрыты, включая соответствующий им функционал.</p>)
                    );
                }
                break;
            case 'notReceiveForForwarding':
                if (this.oldDocumentsLoaded) {
                    ShowAlert('warning',
                        value
                            ? (<p>Для пользователя <b>{this.userName}</b> будут удалены все документы, направленные по пересылке.</p>)
                            : (<p>Для пользователя <b>{this.userName}</b> будут загружены документы, направленные по пересылке.</p>)
                    );
                }
                break;
            case 'useAssistentDictionaries':
                this.ShowLoadAssistentDictionariesModal(value, funcProcessAfterSetValue);
                return;
            case 'gatewayAssistent':
                if (this.oldDocumentsLoaded) {
                    ShowAlert('warning',
                        value
                            ? (<p>Для пользователя <b>{this.userName}</b> будут перезагружены документы для папок "На рассмотрение" и "На контроле" с учетом получения документов на рассмотрение через помощника.</p>)
                            : (<p>Для пользователя <b>{this.userName}</b> будут перезагружены документы для папок "На рассмотрение" и "На контроле" с учетом получения документов на рассмотрение без помощника.</p>)
                    );
                }
                break;
            case 'sendProjectsViaAssistent':
                if (value == true) {
                    this.SetSettingForcibly('gatewayAssistent', value);
                }
                break;
            case 'gatewayVisaAssistant':
                if (this.oldDocumentsLoaded) {
                    ShowAlert('warning',
                        value
                            ? (<p>Для пользователя <b>{this.userName}</b> будут перезагружены проекты документов для папки "На визирование" с учетом получения проектов документов через помощника.</p>)
                            : (<p>Для пользователя <b>{this.userName}</b> будут перезагружены проекты документов для папки "На визирование" с учетом получения проектов документов без помощника.</p>)
                    );
                }
                break;
            case 'gatewaySignAssistant':
                if (this.oldDocumentsLoaded) {
                    ShowAlert('warning',
                        value
                            ? (<p>Для пользователя <b>{this.userName}</b> будут перезагружены проекты документов для папки "На подпись" с учетом получения проектов документов через помощника.</p>)
                            : (<p>Для пользователя <b>{this.userName}</b> будут перезагружены проекты документов для папки "На подпись" с учетом получения проектов документов без помощника.</p>)
                    );
                }
                break;
            case 'isReportRequired':
                if (this.oldDocumentsLoaded) {
                    ShowAlert('warning',
                        value
                            ? (<p>Для пользователя <b>{this.userName}</b> будут перезагружены документы для папок "На рассмотрение" и "На контроле" с учетом исполнения поручений только после ввода отчета (с датой)</p>)
                            : (<p>Для пользователя <b>{this.userName}</b> будут перезагружены документы для папок "На рассмотрение" и "На контроле" без учета исполнения поручений только после ввода отчета (с датой).</p>)
                    );
                }
                break;
            case 'controlFolder':
                if (this.oldDocumentsLoaded) {
                    ShowAlert('warning',
                        value
                            ? (<p>Для пользователя <b>{this.userName}</b> будут загружены документы для папки "На контроле".</p>)
                            : (<p>Для пользователя <b>{this.userName}</b> будут удалены все документы, относящиеся к папке "На контроле". Также будет скрыта папка "На контроле" и соответствующий ей функционал.</p>)
                    );
                }
                break;
            case 'visaFolder':
                if (this.oldDocumentsLoaded) {
                    ShowAlert('warning',
                        value
                            ? (<p>Для пользователя <b>{this.userName}</b> будут загружены проекты документов для папки "На визирование".</p>)
                            : (<p>Для пользователя <b>{this.userName}</b> будут скрыты проекты документов из папки "На визирование".</p>)
                    );
                }
                break;
            case 'signFolder':
                if (this.oldDocumentsLoaded) {
                    ShowAlert('warning',
                        value
                            ? (<p>Для пользователя <b>{this.userName}</b> будут загружены проекты документов для папки "На подпись".</p>)
                            : (<p>Для пользователя <b>{this.userName}</b> будут скрыты проекты документов из папки "На подпись".</p>)
                    );
                }
                break;
            case 'userFolders':
                if (this.oldDocumentsLoaded) {
                    ShowAlert('warning',
                        value
                            ? (<p>Для пользователя <b>{this.userName}</b> будут загружены документы и проекты документов для папки "Избранное".</p>)
                            : (<p>Для пользователя <b>{this.userName}</b> будут удалены все документы и проекты документов, относящиеся к папке "Избранное". Папка "Избранное" будет скрыта.</p>)
                    );
                }
                break;
            case this.GetSettingNameOfCurrentProductMode("EdsArchiveName"):
                this.SetSettingForcibly(this.GetSettingNameOfCurrentProductMode("EdsArchiveAutoUpload"), value?.length > 0);
                break;
            case this.GetSettingNameOfCurrentProductMode("CryptoProLicenseKey"):
                this.SetSettingForcibly(this.GetSettingNameOfCurrentProductMode("CryptoProLicenseKeyAutoUpload"), value?.length > 0);
                break;
            case this.GetSettingNameOfCurrentProductMode("SupportEmail"):
                this[this.GetPropertyNameOfCurrentProductMode("SupportEmailError")] = false;
                break;
        }

        this.SetSettingForcibly(key, value);

        this.AfterSetSettings();
    });

    SetSettingForcibly = action((key, value) => {
        let changed = false;
        if (this.settings[key] == null) {
            this.settings[key] = { value: value, disabled: false };
            changed = true;
        }
        if (this.settings[key].value != value) {
            this.settings[key].value = value;
            changed = true;
        }
        return changed;
    });

    SetSettingsMultipleChildsValuesFromParent(newParentValue, keys) {
        keys.forEach(key => {
            this.SetSettingDisabledValue(key, newParentValue != true);
            if (newParentValue == false) {
                this.SetSettingForcibly(key, newParentValue);
            }
        });
    }

    AfterSetSettings() {
        this.SetSettingsMultipleChildsValuesFromParent(
            this.GetSetting("underConsiderationFolder"),
            [
                "notConsideredFolder",
                "resolutionProjectFolder",
                "resolutionFolder",
                "notReceiveForForwarding",
            ]
        );

        this.SetSettingsMultipleChildsValuesFromParent(
            this.GetSetting("underConsiderationFolder")
            &&
            this.GetSetting("notReceiveForForwarding") == false,
            [
                "familarizationFolder"
            ]
        );

        this.SetSettingsMultipleChildsValuesFromParent(
            this.GetSetting("underConsiderationFolder")
            &&
            this.GetSetting("mainAssistentUserLid") != null
            ,
            [
                "gatewayAssistent",
                "sendProjectsViaAssistent"
            ]
        );
        if (this.GetSetting("sendProjectsViaAssistent")) {
            this.SetSettingForcibly("gatewayAssistent", true);
            this.SetSettingDisabledValue("gatewayAssistent", true);
        }

        this.SetSettingsMultipleChildsValuesFromParent(
            this.GetSetting("gatewayAssistent"),
            [
                "canImprovement"
            ]
        );

        if (this.GetSetting("gatewayAssistent")) {
            this.SetSettingDisabledValue("canReport", false);
            this.SetSettingsMultipleChildsValuesFromParent(
                this.GetSetting("canReport"),
                [
                    "isReportRequired"
                ]
            );
        }
        else {
            this.SetSettingForcibly("canReport", true);
            this.SetSettingDisabledValue("canReport", true);
            this.SetSettingForcibly("isReportRequired", true);
            this.SetSettingDisabledValue("isReportRequired", true);
        }

        this.SetSettingsMultipleChildsValuesFromParent(
            this.GetSetting("sendProjectsViaAssistent") == false,
            [
                "respExecutorRequired"
            ]
        );

        this.SetSettingsMultipleChildsValuesFromParent(
            this.GetSetting("mainAssistentUserLid") != null,
            [
                "useAssistentDictionaries"
            ]
        );

        this.SetSettingDisabledValue("useSimpleEDS",
            this.GetSetting("edsAvailable") != true ||
            this.GetSetting("sesAvailable") != true);

        this.SetSettingsMultipleChildsValuesFromParent(
            (this.GetSetting("edsAvailable") ||
                this.GetSetting("sesAvailable"))
            &&
            this.GetSetting("underConsiderationFolder"),
            [
                "canEdsInitiative",
                "canEdsResolution",
            ]
        );

        this.SetSettingsMultipleChildsValuesFromParent(
            this.GetSetting("canEdsInitiative")
            ||
            this.GetSetting("canEdsResolution"),
            [
                "requireEdsOnResolution"
            ]
        );

        this.SetSettingsMultipleChildsValuesFromParent(
            (this.GetSetting("edsAvailable") ||
                this.GetSetting("sesAvailable"))
            &&
            this.GetSetting("visaFolder"),
            [
                "canEdsVisa"
            ]
        );

        this.SetSettingsMultipleChildsValuesFromParent(
            this.GetSetting("canEdsVisa"),
            [
                "requireEdsOnVisa"
            ]
        );

        this.SetSettingsMultipleChildsValuesFromParent(
            (this.GetSetting("edsAvailable") ||
                this.GetSetting("sesAvailable"))
            &&
            this.GetSetting("signFolder"),
            [
                "canEdsSign"
            ]
        );

        this.SetSettingsMultipleChildsValuesFromParent(
            this.GetSetting("canEdsSign"),
            [
                "requireEdsOnSign"
            ]
        );

        this.SetSettingsMultipleChildsValuesFromParent(
            this.GetSetting("underConsiderationFolder")
            &&
            this.GetSetting("rootRubricId")?.length > 0 == true,
            [
                "rubricsInResolutionFolder"
            ]
        );

        this.SetSettingsMultipleChildsValuesFromParent(
            this.GetSetting("rootRubricId")?.length > 0 == true
            &&
            this.GetSetting("visaFolder"),
            [
                "rubricsInVisaFolder"
            ]
        );
        this.SetSettingsMultipleChildsValuesFromParent(
            this.GetSetting("visaFolder"),
            [
                "canAnnotateForVisa"
            ]
        );

        this.SetSettingsMultipleChildsValuesFromParent(
            this.GetSetting("visaFolder")
            &&
            this.GetSetting("mainAssistentUserLid") != null,
            [
                "gatewayVisaAssistant"
            ]
        );

        this.SetSettingsMultipleChildsValuesFromParent(
            this.GetSetting("rootRubricId")?.length > 0 == true
            &&
            this.GetSetting("signFolder"),
            [
                "rubricsInSignFolder"
            ]
        );
        this.SetSettingsMultipleChildsValuesFromParent(
            this.GetSetting("signFolder"),
            [
                "canAnnotateForSign"
            ]
        );
        this.SetSettingsMultipleChildsValuesFromParent(
            this.GetSetting("signFolder")
            &&
            this.GetSetting("mainAssistentUserLid") != null,
            [
                "gatewaySignAssistant"
            ]
        );

        this.SetSettingsMultipleChildsValuesFromParent(
            this.GetSetting("controlFolder"),
            [
                "superiorControlFolder",
                "personalControlFolder",
                "initiativeControlFolder"
            ]
        );

        this.SetSettingsMultipleChildsValuesFromParent(
            this.GetSetting("selectIntermediateDate"),
            [
                "copyIntermediateDateFromParentRes"
            ]
        );

        this.SetSettingsMultipleChildsValuesFromParent(
            this.GetSetting("newFolder"),
            [
                "newFolderProjects"
            ]
        );

        this.SetSettingsMultipleChildsValuesFromParent(
            this.GetSetting("urgentFolder"),
            [
                "addUrgentProjectsToUrgentFolder"
            ]
        );

        this.SetSettingsMultipleChildsValuesFromParent(
            this.GetSettingOfCurrentProductMode("edsArchiveName")?.length > 0 == true
            ,
            [
                "edsArchiveAutoUpload"
            ]
        );

        this.SetSettingsMultipleChildsValuesFromParent(
            this.GetSettingOfCurrentProductMode("cryptoProLicenseKey")?.length > 0 == true
            ,
            [
                "cryptoProLicenseKeyAutoUpload"
            ]
        );
    }

    SearchAssistent() {
        UserSettingsRequests.SearchAssistent(this.selectAssistent.alias).then(action((values) => {
            if (values.error) {
                ShowAlert('warning',
                    <div>
                        При попытке получить данные из сервера интеграции произошла ошибка.<br />
                        Убедитесь, что сервер интеграции работает, и повторите попытку.
                    </div>
                );
            }
            else {
                if (values.value.length == 0) {
                    ShowAlert('warning',
                        <div>
                            Помощник не найден.
                        </div>
                    );
                } else {
                    this.assistentSearchResult = values.value;
                    this.selectAssistent.list = this.assistentSearchResult.map(item => {
                        return {
                            key: item.userLid,
                            value: item.fullname + (item.duty ? ' - ' + item.duty : '')
                        }
                    });
                }
            }
        }));
    }

    SelectAssistent = action((userLid) => {
        if (userLid == this.userLid) {
            ShowAlert('warning', `Должностное лицо не может быть назначено помощником самому себе. Пожалуйста, выберите другое должностное лицо.`);
            return;
        }

        var mainAssistentUserLidValue = this.settings.mainAssistentUserLid.value;
        var assistentsValue = Array.from(this.settings.assistents.value);

        if (assistentsValue.some(a => a.userLid == userLid))
            return;

        var newAssistent = this.assistentSearchResult.find(a => a.userLid == userLid);

        // если ранее выбран главный помощник, то не меняем
        if (!assistentsValue.some(a => a.userLid == mainAssistentUserLidValue))
            mainAssistentUserLidValue = userLid;

        assistentsValue.push({
            userLid: newAssistent.userLid,
            contactLid: newAssistent.lid,
            name: newAssistent.fullname,
            post: newAssistent.duty,
            deleted: false
        });

        this.UpdateAssistentChildValues(mainAssistentUserLidValue, assistentsValue);
    });

    SetMainAssistent(mainAssistentUserLidValue) {
        this.SetSettingForcibly('mainAssistentUserLid', mainAssistentUserLidValue);
    }

    DeleteAssistent(userLid) {

        var mainAssistentUserLidValue = this.settings.mainAssistentUserLid.value;
        var assistentsValue =
            Enumerable.from(this.settings.assistents.value)
                .where(it => it.userLid != userLid)
                .toArray();

        if (Enumerable.from(assistentsValue)
            .where(it => it.userLid == mainAssistentUserLidValue)
            .count() == 0
        ) {
            mainAssistentUserLidValue =
                assistentsValue.length > 0
                    ? assistentsValue[0].userLid
                    : null;
        }

        this.UpdateAssistentChildValues(mainAssistentUserLidValue, assistentsValue);
    }

    UpdateAssistentChildValues(mainAssistentUserLidValue, assistentsValue) {
        if (assistentsValue == null)
            assistentsValue = this.settings.assistents.value;

        var funcProcessAfterSetValue = () => {
            this.SetSettingForcibly('mainAssistentUserLid', mainAssistentUserLidValue);
            this.SetSettingForcibly('assistents', assistentsValue);

            this.AfterSetSettings();
        };

        if (mainAssistentUserLidValue == null
            &&
            this.settings.useAssistentDictionaries.value
        ) {
            this.SetSetting("useAssistentDictionaries", false, funcProcessAfterSetValue);
        }
        else {
            funcProcessAfterSetValue();
        }
    }

    ShowLoadAssistentDictionariesModal(useAssistentDictionariesValue, funcProcessAfterSetValue) {
        ShowModal({
            canBeClosed: true,
            header: 'Загрузка справочников помощника',
            className: 'load-assistent-dictionaries-block',
            children: (
                <div>
                    {useAssistentDictionariesValue
                        ? <p>Для пользователя <b>{this.userName}</b> будут загружены справочники его главного помощника.</p>
                        : <p>Для пользователя <b>{this.userName}</b> будут загружены его собственные справочники.</p>
                    }
                    <p className='margin-bottom-none'>Продолжить?</p>
                </div>
            ),
            buttons: [
                {
                    content: 'Нет',
                    closer: true
                },
                {
                    content: 'Да',
                    closer: true,
                    onClick: () => this.AcceptUseAssistentDictionariesSetting(useAssistentDictionariesValue, funcProcessAfterSetValue)
                }
            ]
        });
    }
    AcceptUseAssistentDictionariesSetting(useAssistentDictionariesValue, funcProcessAfterSetValue) {
        this.SetSettingForcibly('useAssistentDictionaries', useAssistentDictionariesValue);

        if (funcProcessAfterSetValue != null)
            funcProcessAfterSetValue();
        else
            this.AfterSetSettings();
    }

    UpdateDictionaries() {
        this.needUpdateAfterSyncDictionaries = true;

        UserSettingsRequests.UpdateDictionary(this.userId).then(action((values) => {
            if (values.value) {
                this.SetCurrentUserState(values.value);
            }
        }));
    }

    SetUserState(usersState, usersReloadState, dmsisStatus) {
        this.dmsisStatus = dmsisStatus;

        if (this.userLid === '')
            return;

        this.usersReloadState = usersReloadState;

        var currentUserState = usersState[this.userLid];
        if (currentUserState == null)
            return;

        this.SetCurrentUserState(currentUserState);
    }

    SetCurrentUserState(currentUserState) {
        this.currentUserState = currentUserState;

        let tasks = [
            SynchronizingTask.removingUser,
            SynchronizingTask.removingUserDl,
            SynchronizingTask.loadDocuments,
            SynchronizingTask.removeConsiderationDocuments,
            SynchronizingTask.loadVisaDocuments,
            SynchronizingTask.removeVisaDocuments,
            SynchronizingTask.loadSignDocuments,
            SynchronizingTask.removeSignDocuments,
            SynchronizingTask.loadControlDocuments,
            SynchronizingTask.removeControlDocuments
        ];

        if (tasks.indexOf(currentUserState.task) >= 0 && currentUserState.documentsLoadProgressByFolders != null) {
            this.synchronizing.documents = {
                status: currentUserState.status,
                total: currentUserState.documentsLoadProgressByFolders.total,
                loaded: currentUserState.documentsLoadProgressByFolders.loaded,
                totalFull: currentUserState.documentsLoadProgressFull.total,
                loadedFull: currentUserState.documentsLoadProgressFull.loaded
            }
        } else {
            this.synchronizing.documents = {
                total: 0
            }
        }
        //todo убрать this.synchronizing
        this.synchronizing.task = currentUserState.task;
        this.synchronizing.inProgress = currentUserState.inProgress;
        this.synchronizing.lastSyncInfos = currentUserState.lastSyncInfos;
        this.synchronizing.anomalyCounter = currentUserState.anomalyCounter;

        if (
            this.usersReloadState.inProcess
            &&
            currentUserState.inProgress == false //синхронизация пользователей. пользователь в очереди или ожидание синхронизации остальных пользователей
        ) {
            this.ShowQueueBlockModal();
            this.syncModalTypeOpened = "UsersSyncWaitInQueue";
        }
        else if (
            currentUserState.inProgress == true // синхронизация пользователя. в процессе
        ) {
            this.ShowSyncProcessModal();
            this.syncModalTypeOpened = "UserSyncInProgress";
        }
        else if (
            currentUserState.inProgress == false // синхронизация пользователя. завершена
            &&
            currentUserState.syncResultsViewed == false // результаты синхронизации пользователя. пользователь ещё не нажал "закрыть"
        ) {
            if (this.syncModalTypeOpened != "UserSyncFinished") {
                this.ReloadSettings();
            }
            this.ShowEndOfSyncModal();
            this.syncModalTypeOpened = "UserSyncFinished";
        }
        else if (this.syncModalTypeOpened != "") {
            CloseModal();
            this.syncModalTypeOpened = "";
        }
    }

    ShowQueueBlockModal() {
        ShowModal({
            canBeClosed: false,
            className: 'sync-queue-block synchronizing-block',
            header: 'Синхронизация',
            children: 'На СМР запущен процесс повторной синхронизации активированных пользователей. Во время процесса запрещено вносить изменения в профиль пользователя. Дождитесь окончания...'
        })
    }

    ShowSyncProcessModal() {
        ShowModal({
            getHeader: () => (
                <div className='title-with-indicator'>
                    {this.synchronizing.inProgress
                        ? (
                            <div className='load-view-placeholder '>
                                {IconsContainer.Get('r-spinner')}
                            </div>)
                        : null
                    }
                    {this.GetSyncModalTitle(false)}
                </div>
            ),
            canBeClosed: false,
            children: <SynchronizingModal />,
            className: 'synchronizing-block',
            getButtons: () => this.currentUserState.cancellingAvailable != true ? [] : [{
                content: 'ПРЕРВАТЬ СИНХРОНИЗАЦИЮ',
                className: ("blue-button " + (this.currentUserState.cancellingRequested ? "disabled" : "")),
                onClick: () => this.StopSync(),
                closer: false
            }]
        })
    }

    ShowEndOfSyncModal() {
        ShowModal({
            className: 'synchronizing-block',
            getHeader: () => this.GetSyncModalTitle(true),
            children: (<EndOfSyncModal userLid={this.userLid} />),
            buttons: [{
                content: 'Закрыть',
                className: 'blue-button',
                onClick: () => this.ForceCloseSyncModal(),
                closer: true
            }]
        });
    }

    GetSyncModalTitle(isEnd) {
        const state = this.currentUserState;

        if (state.task == SynchronizingTask.removingUserDl) {
            return (
                isEnd
                    ? "ДОЛЖНОСТНОЕ ЛИЦО УСПЕШНО УДАЛЕНО"
                    : "УДАЛЕНИЕ ДОЛЖНОСТНОГО ЛИЦА"
            );
        }

        return (
            (
                (state.isMeeting == null || state.isAllProductModes)
                    ? ''
                    : (
                        (state.isMeeting == true
                            ? "Совещания"
                            : "Документооборот")
                        + ": "
                    )
            )
            +
            (
                (state.status == SynchronizingStatus.cancelled)
                    ? "Синхронизация не завершена"
                    : "Синхронизация"
            )
        );
    }

    SetEdsAgreementState = action((state) => {
        this.acceptedEdsAgreement = state;
    });

    ExportAnomalies() {
        UserSettingsRequests.GetAnomalies(this.userLid);
    }

    ExportSettings() {
        UserSettingsRequests.ExportUserSettings(this.userId);
    }

    SetCopySettingsFrom = action((value) => {
        this.copySettingsFrom.selectedUser = value;
    });

    SetSelectAssistentAlias = action((value) => {
        this.selectAssistent.alias = value;
    });

    SetRedirectTo404 = action((value) => {
        this.redirectTo404 = value;
    });

    StopSync() {
        UserSettingsRequests.StopSync(this.userId)
            .then((values) => {
                if (values.value) {
                    this.SetCurrentUserState(values.value);
                }
            });
    }

    GetCabinetDLs() {
        UserSettingsRequests.GetCabinetDLs(this.userId).then(action((values) => {
            this.ClearDLs();
            this.cabinetDLs = values;

            TracesStore.AddTrace("userSettingsStore", "GetCabinetDLs", "", {
                cabinetDLsContactLidsToSave: this.cabinetDLsContactLidsToSave,
                cabinetDLs: this.cabinetDLs,
                cabinetDLsContactLidsToAdd: this.cabinetDLsContactLidsToAdd
            });
        }));
    }

    DeleteDl(contactLid) {
        this.settingsAreLoading = true;

        this.needUpdateAfterSyncSettingsDls = true;

        TracesStore.AddTrace("userSettingsStore", "DeleteDl", "before UserSettingsRequests.DeleteDL", {
            userId: this.userId,
            contactLid: contactLid
        });

        UserSettingsRequests.DeleteDL(this.userId, contactLid)
            .then((values) => {
                TracesStore.AddTrace("userSettingsStore", "DeleteDl", "after UserSettingsRequests.DeleteDL", {
                    userId: this.userId,
                    contactLid: contactLid,
                    isSuccess: values.error === null
                });

                if (!values.error) {
                    this.SetCurrentUserState(values.value);
                    this.GetCabinetDLs();
                }
            })
            .finally(action(() => this.settingsAreLoading = false));
    }

    AddDl() {
        this.needUpdateAfterSyncSettingsDls = true;

        this.cabinetDLsContactLidsToSave =
            Enumerable.from(this.cabinetDLs.existed).select(it => it.contactLid)
                .toArray()
                .concat(this.cabinetDLsContactLidsToAdd);

        TracesStore.AddTrace("userSettingsStore", "AddDl", "", {
            cabinetDLsContactLidsToSave: this.cabinetDLsContactLidsToSave,
            cabinetDLs: this.cabinetDLs,
            cabinetDLsContactLidsToAdd: this.cabinetDLsContactLidsToAdd
        });

        this.SaveSettings(true);
    }

    OnCabinetDLSelected(dlContactLid) {
        this.cabinetDLsContactLidsToAdd = [dlContactLid];
        this.cabinetDLLidSelectedFirst =
            (this.cabinetDLsContactLidsToAdd && this.cabinetDLsContactLidsToAdd.length > 0)
                ? this.cabinetDLsContactLidsToAdd[0]
                : null;
    }

    OnCabinetDLClearSelectionStore() {
        this.cabinetDLsContactLidsToAdd = [];
        this.cabinetDLLidSelectedFirst = null;
    }

    settingsChanged() {
        return Object.keys(this.settingsAfterLoad).some(settingKey => {
            let oldValue = this.settingsAfterLoad[settingKey]?.value ?? '';
            let newValue = this.settings[settingKey]?.value ?? '';
            if (JSON.stringify(oldValue) != JSON.stringify(newValue))
                return true;

            return false;
        });
    }
}

export default new UserSettingsStore();